import React, { memo } from 'react';
import {
  Box,
  Typography,
  TextField,
  InputAdornment,
  Tabs,
  Tab,
  styled,
} from '@mui/material';
import { Search as SearchIcon } from '@mui/icons-material';

const HeaderContainer = styled(Box)({
  marginBottom: 32,
});

const SearchContainer = styled(Box)({
  marginBottom: 24,
});

const SearchField = styled(TextField)({
  maxWidth: "400px",
  "& .MuiOutlinedInput-root": {
    borderRadius: "12px",
  },
});

const StyledTabs = styled(Tabs)(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.divider}`,
  "& .MuiTabs-indicator": {
    backgroundColor: "#2563EB",
  },
}));

const StyledTab = styled(Tab)({
  textTransform: "none",
  fontWeight: 600,
  fontSize: "14px",
  color: "#64748B",
  "&.Mui-selected": {
    color: "#2563EB",
  },
});

const Title = styled(Typography)({
  marginBottom: 16,
  fontWeight: 700,
});

const StyledSearchIcon = styled(SearchIcon)({
  color: "text.secondary",
});

const ProposalHeader = memo(({
  title,
  searchQuery = "",
  onSearchChange,
  activeTab = 0,
  onTabChange,
  tabs = ['All Proposals', 'Rejected']
}) => (
  <HeaderContainer>
    <Title variant="h4">
      {title}
    </Title>

    <SearchContainer>
      <SearchField
        fullWidth
        variant="outlined"
        placeholder="Search proposals..."
        value={searchQuery}
        onChange={(e) => onSearchChange(e.target.value)}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <StyledSearchIcon />
            </InputAdornment>
          ),
        }}
      />
    </SearchContainer>

    <StyledTabs value={activeTab} onChange={(_, newValue) => onTabChange(newValue)}>
      {tabs.map((tab) => (
        <StyledTab key={tab} label={tab} />
      ))}
    </StyledTabs>
  </HeaderContainer>
));
ProposalHeader.displayName = 'ProposalHeader';

export default ProposalHeader; 